import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Alert, Button, Form, Image, Input, Modal, Spin } from 'antd';
import { LockOutlined, UserOutlined, LoginOutlined } from '@ant-design/icons';
import { URL_AUTH, URL_COMMON } from '../constants/urls';
import { GET, POST } from '../frameworks/HttpClient'
import logo from '../asset/logo.jpg'
import * as _ from 'lodash'
import { PATH } from '../routes/CustomRoutes';
import Segment from '../common/Segment';
import { useUserContext } from '../hooks/UserSettingProvider';

export default function LoginScreen() {
  const navigate = useNavigate();
	const user = useUserContext();
  const [form] = Form.useForm();
  const [loginSuccess, setLoginSuccess] = React.useState(false);
  const [isLoading, setIsLoading] = React.useState(false);
  const [errorMessages, setErrorMessages] = React.useState(null);
  const passwordRef = React.useRef();

  // Login
  const handleLogin = async (values) => {
    setErrorMessages(null);
    setIsLoading(true);
    try {
      const response = await POST(URL_AUTH.API_TOKEN_AUTH, {...values})
      setLoginSuccess(true)
      user.onLogin(response.data)
    } catch (error) {
      setErrorMessages(error.errorMessages);
    } finally {
      setIsLoading(false);
    }
  }

  const warningLogin = (msg) => {
    Modal.warning({
      title: "แจ้งเตือน",
      content: msg,
    });
  };

  const handleNext = (event, ref) => {
    if ((event.key === "Enter") && ref) {
      ref.current.input.focus();
    }
  }

  React.useEffect(() => {
    // handle to avoid user data set later than route
    if (loginSuccess && _.get(user, 'user.id', null)) {
      navigate(PATH.MAIN, {replace: true});
    }
  }, [loginSuccess, user.user])

  return(
    <div className='center-screen'>
      <div style={{width: "90%", maxWidth: 420}}>
        <Image
          style={{textAlign: "center", width: "100%", maxWidth: 200}}
          src={logo} 
          preview={false} />
        
        <Segment 
          style={{marginTop: 16, padding: 16}}
          detail={
            <Spin spinning={isLoading}>
              {errorMessages && 
                <Alert
                  style={{marginBottom: "12px", textAlign: "left"}}
                  message={errorMessages}
                  type="error"
                  showIcon 
                />}
              <Form
                style={{marginTop: 8, textAlign: "left"}}
                className="login-form"
                form={form}
                onFinish={handleLogin}
                autoComplete={"off"}>
                <Form.Item
                  name="username"
                  rules={[{ required: true, message: 'กรุณากรอกชื่อผู้ใช้!' }]}>
                  <Input 
                    autoCapitalize='none'
                    prefix={<UserOutlined className="site-form-item-icon" />} 
                    placeholder="ชื่อผู้ใช้"
                    onKeyDown={(ev) => handleNext(ev, passwordRef)} />
                </Form.Item>

                <Form.Item
                  name="password"
                  rules={[{ required: true, message: 'กรุณากรอกรหัสผ่าน!' }]}>
                  <Input.Password
                    ref={passwordRef}
                    prefix={<LockOutlined className="site-form-item-icon" />}
                    placeholder="รหัสผ่าน"/>
                </Form.Item>

                <Form.Item style={{margin: 0}}>
                  <Button
                    style={{width: "100%"}}
                    type={"primary"} 
                    htmlType="submit" 
                    icon={<LoginOutlined />}>{"เข้าสู่ระบบ"}</Button>
                </Form.Item>
              </Form>
            </Spin>
          }/>
      </div>
    </div>
  )
}